module.exports = __webpack_public_path__ + "static/media/inmaculada.7eda82d8.png";